'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _decodeJwtToken = require('./decodeJwtToken');

var _decodeJwtToken2 = _interopRequireDefault(_decodeJwtToken);

var _domain = require('../domain');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DAY = 24 * 60 * 60 * 1000;

var TokenCookieStorage = function () {
  function TokenCookieStorage() {
    _classCallCheck(this, TokenCookieStorage);

    this.cookiesAttributes = { domain: (0, _domain.getCookieDomain)(document.location.host) };
  }

  _createClass(TokenCookieStorage, [{
    key: 'get',
    value: function get() {
      return {
        access_token: _jsCookie2.default.get('access_token'),
        refresh_token: _jsCookie2.default.get('refresh_token')
      };
    }
  }, {
    key: 'save',
    value: function save(tokensInfo) {
      try {
        var accessTokenParsed = (0, _decodeJwtToken2.default)(tokensInfo.access_token);
        var refreshTokenParsed = (0, _decodeJwtToken2.default)(tokensInfo.refresh_token);

        _jsCookie2.default.set('access_token', tokensInfo.access_token, _extends({
          path: '/',
          expires: new Date(accessTokenParsed.exp * 1000 + DAY)
        }, this.cookiesAttributes));
        _jsCookie2.default.set('refresh_token', tokensInfo.refresh_token, _extends({
          path: '/',
          expires: new Date(refreshTokenParsed.exp * 1000 + DAY)
        }, this.cookiesAttributes));
      } catch (e) {}
    }
  }, {
    key: 'drop',
    value: function drop() {
      _jsCookie2.default.remove('access_token');
      _jsCookie2.default.remove('access_token', _extends({}, this.cookiesAttributes));
      _jsCookie2.default.remove('refresh_token');
      _jsCookie2.default.remove('refresh_token', _extends({}, this.cookiesAttributes));
    }
  }]);

  return TokenCookieStorage;
}();

exports.default = TokenCookieStorage;


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/application-bootstrapper/dist/authorization/TokenCookieStorage.js
// module id = 1323
// module chunks = 118